import { faHome, faRedo } from "@fortawesome/pro-solid-svg-icons";
import { ActionButton, ErrorPage } from "components";
import React from "react";
import appLogo from '../../../public/icon_512.png';
import './error-boundary.scss';

type Props = {
}

type ErrorState = {
    hasError: boolean
    errorText: string | null
    errorStack: string | null
}

export class ErrorBoundary extends React.Component<Props, ErrorState> {

    constructor(props: any) {
        super(props);
        this.state = {
            hasError: false,
            errorText: null,
            errorStack: null
        };
    }

    static getDerivedStateFromError(error: any) {
        return { hasError: true };
    }

    componentDidCatch(error: any, errorInfo: any) {
        this.setState({
            errorText: error?.toString(),
            errorStack: errorInfo?.componentStack?.toString()
        })
    }

    render() {
        if (this.state.hasError) {
            return (<ErrorPage/>)
        }

        return this.props.children;
    }

}